import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'Hogar de Revista';
render(<App data-id="element-160" />, document.getElementById('root'));